import { apiCall } from "../helpers/api";

export const search =
    (params = {}) =>
    (dispatch) => {
        params.path = params.path || "search";

        return dispatch(apiCall(params));
    };
